import React, { useEffect, useState } from "react";
import { BiSolidSun, BiSolidMoon } from "react-icons/bi";
import { HiMenuAlt3, HiMenuAlt1 } from "react-icons/hi";
import { FaCaretDown } from "react-icons/fa";
import ResponsiveMenu from "./ResponsiveMenu";
import { FaMoneyBillWave } from "react-icons/fa";
import { socket } from "../../api";
import { parseJWT } from "../../utils/jwtUtils";
import { Link } from "react-router-dom";
import { FaWallet } from "react-icons/fa";
import { useTranslation } from "react-i18next";

const TopHeader = () => {
  const [balance, setBalance] = useState(0);
  const token = localStorage.getItem("userInfo")
    ? JSON.parse(localStorage.getItem("userInfo"))
    : null;
  const userInfo = parseJWT(token?.token);

  useEffect(() => {
    if (userInfo?.phone) {
      //   console.log("Requesting balance for phone:", userInfo.phone);
      socket.emit("getBalance", { phone: userInfo.phone });

      socket.on("balanceResponse", (data) => {
        //  console.log("Received balance response from server:", data);
        if (data.success) {
          setBalance(data.balance);
        }
      });
    }

    return () => {
      socket.off("balanceResponse");
    };
  }, [userInfo?.phone]);

  const { t: translate, i18n } = useTranslation(["header"]);

  return (
    <div className="flex md:hidden justify-between items-center w-full px-4 py-1 text-white">
      <div className="flex items-center gap-4 text-xs">
        <div
          className="
            inline-flex items-center gap-2 px-4 py-2 rounded-lg border border-primary/50 bg-gradient-to-l from-cyan-750 via-cyan-600 to-cyan-750 text-white font-semibold text-sm
            shadow-lg hover:shadow-xl hover:scale-105 transition-all duration-200 active:scale-95
          "
        >
          <button className="text-sm" onClick={() => window.location.reload()}>
            Refresh
          </button>
        </div>
      </div>

      <div className="flex items-center gap-4">
        <Link
          to="/wallet"
          className="
            inline-flex items-center gap-2
            px-4 py-2
            rounded-full
            border border-primary/50
            bg-gradient-to-l from-cyan-950 via-cyan-800 to-cyan-950
            text-white font-semibold text-sm
            shadow-lg
            hover:shadow-xl hover:scale-105
            transition-all duration-200
            active:scale-95
          "
        >
          <FaWallet className="text-green-200 text-sm" />
          <span className="text-sm">
            {balance} {translate("ETB")}
          </span>
        </Link>
      </div>
    </div>
  );
};

export default TopHeader;
